module.exports = __webpack_public_path__ + "img/s7.0.1.0_202602021803.jpg";